module.exports = __webpack_public_path__ + "img/mobile-menu-dark.e52e37bb.svg";